// Persiste y limpia las cookies de perfil de sesión usadas por la UI (rol, negocio, RBAC).
import cookie from 'react-cookies'
import { clearRbacCookies, saveRbacCookies } from '../rbac/utils/rbacCookies'

const COOKIE_OPTIONS = { path: '/' }

const PROFILE_COOKIE_KEYS = [
  'business_id',
  'business_tenant_uid',
  'business_name',
  'business_url',
  'user_name',
  'user_email',
  'user_role',
  'id',
  'intl_locale',
  'intl_currency',
  'mfa_enabled',
  'security_configured'
]

export function isMfaEnabled() {
  const value = cookie.load('mfa_enabled')
  return value === true || value === 'true'
}

export function setMfaEnabledCookie(enabled) {
  cookie.save('mfa_enabled', enabled ? 'true' : 'false', COOKIE_OPTIONS)
}

export function isSecurityConfigured() {
  const value = cookie.load('security_configured')
  if (value === undefined || value === null) return false
  return value === true || value === 'true'
}

export function setSecurityConfiguredCookie(configured) {
  cookie.save('security_configured', configured ? 'true' : 'false', COOKIE_OPTIONS)
}

export function saveSessionCookies(payload = {}, { email } = {}) {
  if (payload.business_id !== undefined) {
    cookie.save('business_id', payload.business_id, COOKIE_OPTIONS)
  }
  if (payload.business_tenant_uid !== undefined) {
    cookie.save('business_tenant_uid', payload.business_tenant_uid, COOKIE_OPTIONS)
  }
  if (payload.business_name !== undefined) {
    cookie.save('business_name', payload.business_name, COOKIE_OPTIONS)
  }
  if (payload.business_url !== undefined) {
    cookie.save('business_url', payload.business_url, COOKIE_OPTIONS)
  }
  if (payload.user_name !== undefined) {
    cookie.save('user_name', payload.user_name, COOKIE_OPTIONS)
  }

  const resolvedEmail = email ?? payload.email
  if (resolvedEmail !== undefined) {
    cookie.save('user_email', resolvedEmail, COOKIE_OPTIONS)
  }

  if (payload.user_role) {
    cookie.save('user_role', payload.user_role, COOKIE_OPTIONS)
  } else if (payload.user_role === null) {
    cookie.remove('user_role', COOKIE_OPTIONS)
  }

  if (payload.id !== undefined && payload.id !== null) {
    cookie.save('id', payload.id, COOKIE_OPTIONS)
  }

  if (payload.intl_locale !== undefined) {
    cookie.save('intl_locale', payload.intl_locale, COOKIE_OPTIONS)
  }
  if (payload.intl_currency !== undefined) {
    cookie.save('intl_currency', payload.intl_currency, COOKIE_OPTIONS)
  }

  if (payload.mfa_enabled !== undefined) {
    setMfaEnabledCookie(Boolean(payload.mfa_enabled))
  }
  if (payload.security_configured !== undefined) {
    setSecurityConfiguredCookie(Boolean(payload.security_configured))
  }

  saveRbacCookies({
    rbac_permissions: payload.rbac_permissions || [],
    rbac_roles: payload.rbac_roles || [],
    rbac_is_admin: !!payload.rbac_is_admin,
    can_manage_rbac: !!payload.can_manage_rbac || !!payload.rbac_is_admin,
    warehouse_uid: payload.warehouse_uid,
    warehouse_name: payload.warehouse_name
  })
}

export function clearSessionCookies() {
  PROFILE_COOKIE_KEYS.forEach((key) => cookie.remove(key, COOKIE_OPTIONS))
  clearRbacCookies()
}

export function hasSessionUser(payload) {
  if (!payload || typeof payload !== 'object') return false
  if (payload.rbac_is_admin) return true
  if (Array.isArray(payload.rbac_roles) && payload.rbac_roles.length > 0) return true
  if (payload.user_role) return true
  return payload.id != null
}
